// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__CMWrj","col":"styles_col__3WWFS","fulfillmentStatus":"styles_fulfillmentStatus__1s0oI","emailCol":"styles_emailCol__uols7"};